import { ConditionForFetchHandler } from '../../cache-logic-interface';

export let neverFetchCondition: ConditionForFetchHandler = () => false;
export let alwaysFetchCondition: ConditionForFetchHandler = () => true;
